import { object, string, TypeOf } from 'zod';

const COMMON_PASSWORDS = new Set([
    'password',
    'password1',
    'qwerty',
    'qwerty123',
    '12345678',
    '123456789',
    '1234567890',
    '11111111',
    'admin123',
]);

const RegisterScheme = object({
    email: string().min(1, 'Email обязательное поле').email('Поле Email не валидно'),
    password: string()
        .min(1, 'Поле пароля обязательное')
        .min(8, 'Пароль должен содержать минимум 8 символов')
        .refine((value) => !/^\d+$/.test(value), 'Пароль не может состоять только из цифр')
        .refine((value) => !COMMON_PASSWORDS.has(value.toLowerCase()), 'Пароль слишком простой'),
    password2: string().min(1, 'Поле подтверждения пароля обязательное'),
}).refine((data) => data.password === data.password2, {
    path: ['password2'],
    message: 'Пароли не совпадают',
});

export type TypeRegisterScheme = TypeOf<typeof RegisterScheme>;

export default RegisterScheme;
